import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { CatalogSetupLayout } from '@/features/dictionary';

/** Layout of the catalog setup tabs: page header, line tabs, then the tab's route. */
export const Route = createFileRoute('/_authed/_active/org/catalog-setup')({
  staticData: { crumb: 'common:nav.catalogSetup' },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'products.read');
  },
  component: CatalogSetupLayout,
});
